module.exports = __webpack_public_path__ + "static/noticias-15--53c4fb9ccc08619672f125f9c949147b.jpg";